module.exports = __webpack_public_path__ + "img/placeholder-img.82a33a43.png";